module.exports = __webpack_public_path__ + "static/hc_logo-36d6c946b5a59ee3f869f5d3cd9097db.png";